import {
    FETCH_RAINPRO_STORAGE_LOGS,
    CLEAN_RAINPRO_STORAGE_LOGS,
} from '../actions/types';

const RAINPRO_STORAGE_LOGS_DEFAULT_STATE = {};

const RainproStorageLogsReducer = (state = RAINPRO_STORAGE_LOGS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_RAINPRO_STORAGE_LOGS:
            return payload;

        case CLEAN_RAINPRO_STORAGE_LOGS:
            return RAINPRO_STORAGE_LOGS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default RainproStorageLogsReducer;
